<template>
  <div
    class="custom-select"
    :tabindex="tabindex"
    :style="rootStyles"
    :class="rootCss"
    @blur="open = false"
  >
    <div class="selected" :class="{ open: open }" @click="open = !open">
      {{ selected }}
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(key, value, i) of options"
        :key="i"
        @click="handleClick(key, value)"
      >
        {{ key }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["init", "input"],
  props: {
    options: {
      type: Object,
      required: true,
    },
    zIndex: {
      type: Number,
      default: 100,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    defaultKey: {
      type: String | Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: "",
      open: false,
    };
  },
  watch: {
    defaultKey() {
      this.setSelectedKey();
    },
  },
  computed: {
    rootStyles() {
      return {
        'z-index': this.zIndex,
      };
    },
    rootCss() {
      return {
        'custom-select_disabled': !!(this.disabled),
      };
    },
  },
  methods: {
    handleClick(key, value) {
      this.selected = key;
      this.open = false;
      this.$emit("input", value);
    },
    setSelectedKey() {
      if (this.defaultKey) {
        this.selected = this.options[this.defaultKey];
        this.$emit("init", this.defaultKey);
        return;
      }
      const firstValue = Object.values(this.options).shift();
      this.selected = firstValue;
      const firstKey = Object.keys(this.options).shift();
      this.$emit("init", firstKey);
    },
  },
  mounted() {
    this.setSelectedKey();
  },
};
</script>

<style scoped>
@keyframes appearing-submenu {
  0% {
    opacity: 0;
    transform: translateY(-20%);
  }
  100% {
    opacity: 1;
    transform: translateY((0));
  }
}

.custom-select {
  display: inline-block;
  width: inherit;
  text-align: left;
  outline: none;
  height: 40px;
  line-height: 40px;
  z-index: 10;
}

.custom-select_disabled {
  pointer-events: none;
}

.custom-select_disabled .selected {
  color: #555 !important;
  background-image: none !important;
  background-color: #eee !important;
  border: 1px solid #ccc !important;
}

.custom-select .selected {
  background-color: #fff;
  outline: none;
  border-radius: 6px;
  border: 1px solid #337ab7;
  color: #000;
  padding-left: 1em;
  padding-right: 4em;
  cursor: pointer;
  user-select: none;
}

.custom-select .selected.open {
  box-shadow: 3px 5px 31px -3px rgba(51, 122, 183, 0.51);
  border-radius: 6px 6px 0px 0px;
}

.custom-select .items {
  animation: appearing-submenu 0.3s;
  color: #000;
  border-radius: 0px 0px 6px 6px;
  overflow: hidden;
  border-right: 1px solid #337ab7;
  border-left: 1px solid #337ab7;
  border-bottom: 1px solid #337ab7;
  box-shadow: 3px 5px 31px -3px rgba(51, 122, 183, 0.51);
  background-color: #fff;
}

.custom-select .items div {
  color: #000;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}

.custom-select .items div:hover {
  color: #fff;
  background-color: #337ab7;
  cursor: pointer;
}

.selectHide {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/Select.vue